import { Link, Navigate, NavLink, Route, Routes } from "react-router-dom";
import { useAppData } from "./api/useAppData";
import HomePage from "./pages/HomePage";
import HeadToHeadsPage from "./pages/HeadToHeadsPage";
import FixturesPage from "./pages/FixturesPage";
import StandingsPage from "./pages/StandingsPage";
import StatsPage from "./pages/StatsPage";
import PlayersPage from "./pages/PlayersPage";
import PlayerPage from "./pages/PlayerPage";
import TeamsPage from "./pages/TeamsPage";
import RulesPage from "./pages/RulesPage";
import DebugPage from "./pages/DebugPage";
import DataFreshnessBanner from "./components/DataFreshnessBanner";
import SimulationBanner from "./components/SimulationBanner";

const navItems = [
  { to: "/", label: "Home", end: true },
  { to: "/head-to-heads", label: "H2H" },
  { to: "/fixtures", label: "Fixtures" },
  { to: "/standings", label: "Standings" },
  { to: "/stats", label: "Stats" },
  { to: "/players", label: "Players" },
  { to: "/teams", label: "Teams" },
  { to: "/rules", label: "Rules" },
];

export default function App() {
  const appState = useAppData();
  const { data } = appState;

  return (
    <div className="app">
      <header className="app-header">
        <div className="page">
          <Link to="/" className="brand">
            Biffles World Cup Sweepstake
          </Link>
          <nav className="primary-nav" aria-label="Primary">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  "nav-link" + (isActive ? " is-active" : "")
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      </header>

      <main className="page app-main">
        <SimulationBanner state={appState} />
        <DataFreshnessBanner state={appState} />
        <Routes>
          <Route path="/" element={<HomePage state={appState} />} />
          <Route
            path="/head-to-heads"
            element={<HeadToHeadsPage state={appState} />}
          />
          <Route path="/fixtures" element={<FixturesPage state={appState} />} />
          <Route path="/standings" element={<StandingsPage state={appState} />} />
          <Route path="/stats" element={<StatsPage state={appState} />} />
          <Route path="/players" element={<PlayersPage state={appState} />} />
          <Route
            path="/player/:person"
            element={<PlayerPage state={appState} />}
          />
          <Route path="/teams" element={<TeamsPage state={appState} />} />
          <Route path="/rules" element={<RulesPage />} />
          <Route path="/debug" element={<DebugPage state={appState} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      <footer className="app-footer">
        <div className="page tz-note">
          Times shown in your local timezone:{" "}
          {Intl.DateTimeFormat().resolvedOptions().timeZone}
          {data?.lastUpdated ? (
            <span> · Last updated {new Date(data.lastUpdated).toLocaleString()}</span>
          ) : null}
        </div>
      </footer>
    </div>
  );
}
